var _g, _g2, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStargroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138,
    height: 77,
    viewBox: "0 0 138 77",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_7082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3379 34.0715L59.5229 38.7847C59.2638 38.927 58.9703 39.0019 58.6712 39.0019C57.0895 39.0019 56.2134 37.7165 56.5115 36.3019C57.1604 33.2028 57.783 30.1252 58.3792 27.0691C58.4157 26.8813 58.363 26.7228 58.221 26.5937C55.962 24.5042 53.5691 22.3344 51.0424 20.0844C49.625 18.8166 50.1907 16.6918 52.1253 16.4453C55.3617 16.0305 58.6408 15.6373 61.9624 15.2655C62.2219 15.2342 62.4065 15.1051 62.516 14.8781C63.8949 12.0373 65.2718 9.19251 66.6467 6.34383C67.5775 4.41863 69.9014 4.62993 70.7409 6.5434C71.9819 9.3549 73.4481 12.1312 74.7804 14.9192C74.8696 15.1031 75.0176 15.2068 75.2245 15.2303L85.4144 16.4688C85.7417 16.5105 86.0453 16.655 86.2782 16.8796C87.3611 17.9362 87.357 18.9692 86.2661 19.9788C83.9097 22.1622 81.4905 24.3848 79.0084 26.6465C78.8908 26.7522 78.8482 26.8794 78.8807 27.0281C79.5093 30.1663 80.1379 33.3241 80.7666 36.5015C81.162 38.4678 79.1301 39.536 77.4328 38.6204C74.4883 37.0278 71.6615 35.5115 68.9523 34.0715C68.8574 34.0211 68.7511 33.9947 68.6436 33.9947C68.5361 33.9947 68.4309 34.0211 68.3379 34.0715Z",
    fill: "#19AD6F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_7082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0837 35.8943L45.3605 42.357C45.4146 42.6278 45.3888 42.9082 45.2862 43.165C45.1835 43.4219 45.0083 43.6445 44.7812 43.8066C44.554 43.9686 44.2845 44.0634 44.0044 44.0796C43.7243 44.0959 43.4453 44.033 43.2003 43.8983L37.1979 40.6253C37.0083 40.5221 36.8187 40.5221 36.6292 40.6253C34.7373 41.6925 32.7224 42.7875 30.5844 43.9102C29.3864 44.5351 28.3033 43.3687 28.5271 42.1964C28.9628 39.9588 29.3884 37.8125 29.8039 35.7574C29.8482 35.5233 29.7817 35.325 29.6042 35.1623L24.6486 30.6753C24.3917 30.4429 24.2257 30.1294 24.1793 29.7891C24.1329 29.4489 24.209 29.1035 24.3944 28.8126C24.6647 28.3921 25.0439 28.1521 25.532 28.0926C27.7022 27.8347 29.9269 27.5788 32.206 27.3249C32.436 27.2971 32.5993 27.1801 32.6961 26.9738L35.6066 20.8205C35.7234 20.5759 35.9085 20.3688 36.1402 20.2235C36.372 20.0781 36.6408 20.0006 36.9151 20C37.1894 19.9994 37.4579 20.0757 37.6891 20.2199C37.9203 20.3642 38.1047 20.5705 38.2205 20.8146L41.1491 26.9321C41.1988 27.0358 41.2744 27.1252 41.3686 27.1919C41.4629 27.2585 41.5727 27.3002 41.6876 27.313L48.3798 28.1045C48.5888 28.1289 48.7899 28.1973 48.9694 28.305C49.149 28.4127 49.3027 28.5572 49.4199 28.7285C49.5372 28.8998 49.6153 29.0939 49.6488 29.2974C49.6823 29.501 49.6705 29.7091 49.6142 29.9076C49.5093 30.2806 49.2975 30.6118 48.9788 30.9014C47.4823 32.2464 45.9373 33.6508 44.3439 35.1147C44.11 35.3289 44.0232 35.5888 44.0837 35.8943Z",
    fill: "#19AD6F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_7082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.55 35.8107C107.937 37.8134 108.35 39.9112 108.788 42.1042C109.042 43.3772 107.967 44.5133 106.668 43.8352C104.591 42.7486 102.618 41.668 100.749 40.5933C100.548 40.4783 100.342 40.4763 100.133 40.5873L94.0869 43.9066C93.8487 44.0372 93.5777 44.0981 93.3056 44.0822C93.0335 44.0663 92.7716 43.9742 92.5509 43.8167C92.3301 43.6593 92.1596 43.443 92.0593 43.1934C91.9591 42.9438 91.9332 42.6712 91.9849 42.4076L93.2956 35.7453C93.3439 35.5113 93.2795 35.315 93.1023 35.1564C91.4594 33.6891 89.8447 32.2019 88.2582 30.695C87.1045 29.5945 87.775 28.2204 89.2125 28.0538C91.3789 27.8 93.5513 27.5482 95.7298 27.2984C95.9472 27.2746 96.1002 27.1675 96.1888 26.9772C97.0747 25.1054 98.0109 23.1245 98.9975 21.0346C99.2189 20.5587 99.5773 20.2375 100.073 20.071C100.382 19.966 100.72 19.9778 101.022 20.1042C101.323 20.2305 101.566 20.4625 101.703 20.755L104.633 26.9474C104.734 27.1576 104.903 27.2766 105.14 27.3043C107.399 27.5581 109.6 27.81 111.742 28.0598C112.787 28.1788 113.596 29.3447 112.932 30.2845C112.69 30.6256 112.406 30.9369 112.08 31.2185C110.631 32.4756 109.193 33.7803 107.768 35.1326C107.57 35.319 107.498 35.545 107.55 35.8107Z",
    fill: "#19AD6F"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1_7082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7087 47.8317C17.3606 46.4674 18.0385 45.0547 18.7424 43.5935C18.9184 43.2292 19.1824 42.9598 19.5343 42.7854C19.6575 42.7231 19.7924 42.6855 19.9308 42.6749C20.0692 42.6644 20.2083 42.6811 20.3396 42.7241C20.4709 42.767 20.5916 42.8353 20.6945 42.9248C20.7974 43.0143 20.8803 43.1231 20.9381 43.2447L23.0919 47.7445C23.158 47.8797 23.2576 47.9964 23.3814 48.0838C23.5051 48.1712 23.6491 48.2264 23.7998 48.2444L28.8391 48.849C29.0528 48.8755 29.2544 48.9601 29.4205 49.0931C29.5866 49.226 29.7104 49.4019 29.7776 49.6003C29.8448 49.7986 29.8526 50.0114 29.8001 50.2138C29.7476 50.4163 29.637 50.6002 29.481 50.7443L25.6535 54.2441C25.4935 54.3914 25.4356 54.5716 25.4796 54.7848L26.4754 59.6915C26.5189 59.9049 26.4984 60.126 26.4164 60.3285C26.3343 60.531 26.1942 60.7066 26.0125 60.8344C25.8307 60.9622 25.6151 61.0369 25.3909 61.0496C25.1668 61.0624 24.9436 61.0128 24.7476 60.9065L20.2422 58.4764C20.1453 58.4248 20.0367 58.3977 19.9265 58.3977C19.8164 58.3977 19.7082 58.4248 19.6123 58.4764L14.9389 60.9879C14.8367 61.0428 14.7241 61.0764 14.6083 61.0864C14.4925 61.0964 14.3763 61.0827 14.267 61.0461C13.5431 60.8058 13.2571 60.3077 13.4091 59.5519C13.7411 57.8815 14.061 56.2944 14.369 54.7906C14.413 54.5658 14.349 54.3759 14.177 54.2208L10.3615 50.7559C10.2033 50.6133 10.0905 50.4298 10.0362 50.2271C9.98204 50.0244 9.98875 49.8109 10.0556 49.6117C10.1224 49.4126 10.2465 49.2361 10.4134 49.103C10.5803 48.9699 10.7829 48.8859 10.9974 48.8607L16.1508 48.227C16.4147 48.196 16.6007 48.0642 16.7087 47.8317Z",
    fill: "#19AD6F"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1_7082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.243 47.7777C114.922 46.3821 115.672 44.1665 116.699 42.957C116.774 42.8694 116.868 42.7986 116.974 42.7494C117.08 42.7003 117.195 42.6739 117.312 42.6721C117.84 42.6643 118.219 42.8911 118.447 43.3524C119.147 44.748 119.874 46.2386 120.627 47.8242C120.68 47.9359 120.762 48.0325 120.865 48.1048C120.968 48.1771 121.089 48.2227 121.215 48.2371L126.338 48.8593C126.553 48.8862 126.756 48.9716 126.923 49.1056C127.09 49.2396 127.215 49.4167 127.282 49.6164C127.349 49.8161 127.356 50.0301 127.303 50.2337C127.25 50.4373 127.138 50.6221 126.981 50.7666L123.155 54.2324C122.987 54.3836 122.925 54.5697 122.969 54.7907L123.984 59.8207C124.034 60.0663 123.982 60.3211 123.84 60.5301C123.443 61.1155 122.925 61.2415 122.284 60.9081C120.755 60.1134 119.242 59.3031 117.744 58.4774C117.54 58.365 117.334 58.365 117.126 58.4774L112.579 60.9139C112.384 61.0188 112.162 61.0675 111.94 61.0543C111.717 61.0411 111.503 60.9666 111.322 60.8395C111.142 60.7125 111.003 60.5381 110.921 60.337C110.839 60.1359 110.819 59.9164 110.862 59.7044L111.871 54.779C111.915 54.5697 111.857 54.3933 111.697 54.2499L107.871 50.7783C107.711 50.6335 107.596 50.4475 107.541 50.242C107.486 50.0364 107.492 49.8199 107.56 49.6179C107.627 49.4158 107.753 49.2366 107.922 49.1012C108.091 48.9658 108.296 48.8799 108.514 48.8535L113.57 48.2487C113.883 48.2138 114.107 48.0568 114.243 47.7777Z",
    fill: "#19AD6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_7082",
    x: 40.252,
    y: 0,
    width: 56.8354,
    height: 54.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7082",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_7082",
    x: 14.166,
    y: 15,
    width: 45.5015,
    height: 44.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7082",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_7082",
    x: 77.6719,
    y: 15,
    width: 45.5015,
    height: 44.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7082",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1_7082",
    x: 0,
    y: 37.6719,
    width: 39.8345,
    height: 38.418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7082",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1_7082",
    x: 97.5039,
    y: 37.6719,
    width: 39.8345,
    height: 38.418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7082",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStargroup);
export default __webpack_public_path__ + "static/media/stargroup.dcfbb566a6cdef68795c3d8c93ddcaaa.svg";
export { ForwardRef as ReactComponent };